export const __kelvinToFahrenheit = (kelvin) => {
    return Math.round((kelvin - 273.15) * 9/5 + 32);
};